export default __webpack_public_path__ + "media/images/brands/demo/backgrounds/bg-01-ad5e875ae7751e122e8239ee05948039.jpg";